import React, { useEffect } from 'react';
import { CircularProgress } from '@material-ui/core';

export default function FlowView(props) {
  const {
    showOpenFlowButton,
    flowLoading,
    serverName,
    parseAndLoadPcapCsvData,
    setShowOpenFlowButton,
    setFlowLoading,
    setIsDataReady,
    setGraphData,
    onEngineStop,
    setSnackbarOpen,
    setSnackbarMessage,
    setSnackbarSeverity,
  } = props || {};

  useEffect(() => {
    if (!showOpenFlowButton) return;
    try {
      if (typeof setFlowLoading === 'function') setFlowLoading(false);
    } catch (e) {
    }
  }, [showOpenFlowButton, setFlowLoading]);

  const handleLoadLatestFlows = async (minutes) => {
    try {
      if (typeof setFlowLoading === 'function') setFlowLoading(true);
      if (typeof setIsDataReady === 'function') setIsDataReady(false);
      if (typeof setGraphData === 'function') setGraphData({ nodes: [], links: [] });

      const base = serverName ? String(serverName) : '';
      const m = Number.isFinite(Number(minutes)) ? Math.floor(Number(minutes)) : 10;
      const url = `${base}/api/flows/latest?minutes=${encodeURIComponent(String(m))}`;
      const resp = await fetch(url, { credentials: 'include' });
      if (!resp || !resp.ok) {
        throw new Error(`fetch failed (status=${resp ? resp.status : 'n/a'})`);
      }
      const csvText = await resp.text();

      if (typeof parseAndLoadPcapCsvData === 'function') {
        await parseAndLoadPcapCsvData(csvText);
      }

      try {
        if (typeof setShowOpenFlowButton === 'function') setShowOpenFlowButton(false);
      } catch (e) {
      }
    } catch (e) {
      try {
        if (typeof setSnackbarSeverity === 'function') setSnackbarSeverity('error');
        if (typeof setSnackbarMessage === 'function') setSnackbarMessage('Failed to load flows');
        if (typeof setSnackbarOpen === 'function') setSnackbarOpen(true);
      } catch (e2) {
      }
    } finally {
      try {
        if (typeof setIsDataReady === 'function') setIsDataReady(true);
        if (typeof onEngineStop === 'function') onEngineStop();
      } catch (e) {
      }
      try {
        if (typeof setFlowLoading === 'function') setFlowLoading(false);
      } catch (e) {
      }
    }
  };

  return (
    <>
      {showOpenFlowButton && (
        <div
          style={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '10px',
            zIndex: 1000,
          }}
        >
          <button
            onClick={() => handleLoadLatestFlows(10)}
            disabled={!!flowLoading}
            style={{
              width: '320px',
              height: '56px',
              padding: '12px 26px',
              fontSize: '18px',
              fontWeight: 'bold',
              backgroundColor: '#28a745',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
              opacity: flowLoading ? 0.8 : 1,
              whiteSpace: 'nowrap',
            }}
          >
            {flowLoading ? (
              <span style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <CircularProgress size={16} style={{ color: 'white' }} />
                Loading Flows...
              </span>
            ) : (
              'Load latest 10 minutes'
            )}
          </button>
        </div>
      )}
    </>
  );
}
